import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import IArticleListItem from '../../../interfaces/articles/articleListItem';
import { Columns, Container } from '../../base/grid';
import { H2 } from '../../base/typography';
import ArticleBoxCube from '../articleBoxCube';
import * as StyledArticleList from './articleList.styles';
import ArticleListLoader from './articleListLoader';

interface Props {
	articles: IArticleListItem[];
	loading: boolean;
	error: boolean;
	category: number;
	paddingOff: boolean;
}

const ArticleList: FC<Props> = ({ articles, loading, error, category, paddingOff = false }) => {
	const { t } = useTranslation('common');
	if (error) return <H2>{t('article.something-went-wrong')}</H2>;
	if (loading) return <ArticleListLoader />;
	return (
		<Container paddingOff={paddingOff}>
			<Columns>
				{!error &&
					articles.map((article, index) => {
						if (article.Title === null) return null;
						return (
							<StyledArticleList.ArticleColumn
								key={article.Id}
								tablet={1 / 2}
								desktopSmall={1 / 3}
								lastInLine={index % 3 === 0}>
								<ArticleBoxCube article={article} />
							</StyledArticleList.ArticleColumn>
						);
					})}
				{!error && !loading && articles.length === 0 && (
					<StyledArticleList.NoArticlesFound>
						<span>
							{category === 1607 ? t('article.no-news-found').toString() : t('article.no-blog-found').toString()}
							...
						</span>
					</StyledArticleList.NoArticlesFound>
				)}
			</Columns>
		</Container>
	);
};

export default ArticleList;
